import UIModal from "../../../../shared/components/UIModal";
import React, { useEffect, useState } from "react";
import "./displayPaper.scss";
import {
  PreviousPaperModel,
  PreviousPaperQuestionsModel,
} from "../../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import Description from "../../../CourseStructure/Chapters/DisplayExercise/Description";
import DisplayQuestion from "../../../CourseStructure/Chapters/DisplayExercise/DisplayQuestion";
import { PreviousPaperService } from "../../../../services/ExamService/PreviousPaperService/previouspaper.service";
interface DisplayPaperProps {
  visible: boolean;
  closeModal: () => void;
  paper: any;
}
export const DisplayPaper = ({ paper, ...rest }: DisplayPaperProps) => {
  const [questions, setQuestions] = useState<any[]>([]);
  const genTime = (timeOption?: string, time?: any) => {
	switch (timeOption) {
		case "whole_quiz":
            console.log(time);
			return "Whole Quiz" + " - " + time + "mins";
		case "per_question":
			return "Per Question" + " - " + time + "sec";
		default:
            console.log({default: time});
			return "No Timer";
	}
};

  const fetchQuestions = () => {
    PreviousPaperService.fetchQuestionsbyPaper(
      paper?.id,
      (response: PreviousPaperQuestionsModel[]) => {
        setQuestions(response);
        console.log(response)
      },
      (error: any) => {}
    );
  };

  useEffect(() => {
    if(paper){
      fetchQuestions();
    }
    
  }, [paper]);

  return (
    <UIModal {...rest} noControl>
      <div className="display-exercise">
        <h1 className="title">{paper?.title}</h1>
        <p className="timing">
          {genTime(paper?.timerOptions, paper?.time)}
        </p>
        <Description showLength={100} text={""} className="description" />
        <div className="question__wrapper">
          {questions?.map((question, index) => (
            <DisplayQuestion question={question} index={index} />
          ))}
        </div>
      </div>
    </UIModal>
  );
};
